import React, { useEffect } from "react";
import HighlightsNavigation from "./HighlightsNavigation";
import SectionWrapper from "./sections/SectionWrapper";
import { CarConfigHighlightSection } from "../../../utils/types/SectionTypes";
import ContentSection from "./sections/ContentSection";
import styles from "./Highlights.module.scss";
import { useAphStepTracking } from "../../../hooks/useAphStepTracking";
import { useCarConfigSelector } from "../../../redux/store";
import { numberIsEven } from "../../../utils/typedUtils";
import useSectionIntersectionObserver from "../../../hooks/useSectionIntersectionObserver";
import { CarConfigStep } from "../../../../../../common-deprecated/features/apheleia/utils/carConfigNavigationUtils";
import { useComponentRegistry } from "../componentRegistry";

const Highlights: React.FC = () => {
    const gradeFeatures = useCarConfigSelector((state) =>
        state.grades.items.find((grade) => grade.id === state.car.grade.id),
    )?.gradeFeatures.filter(({ valid }) => valid);

    const HighlightsHero = useComponentRegistry("HighlightsHero");

    const allSections = gradeFeatures?.map((gradeFeature) => gradeFeature.id) || [];
    // Creates a Mappable collection of all the sections and their Refs
    const sectionRefs = new Map(
        [CarConfigHighlightSection.SectionHeader, ...(allSections as CarConfigHighlightSection[])].map((section) => [
            section,
            React.createRef<HTMLElement>(),
        ]),
    );

    useSectionIntersectionObserver<CarConfigHighlightSection>(sectionRefs);

    const trackStep = useAphStepTracking();

    useEffect(() => {
        trackStep(CarConfigStep.Highlights);

        // UseEffect only needs to run once
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (!gradeFeatures) return null;

    return (
        <div className={styles.wrapper} id="tab-highlights">
            {/*TODO FYI: This section wrapper has some more attributes added as this is a full-width one*/}
            <HighlightsHero sectionRef={sectionRefs.get(CarConfigHighlightSection.SectionHeader)} />

            <main data-testid="highlights-step">
                {gradeFeatures.map((gradeFeature, index) => (
                    <SectionWrapper
                        sectionId={gradeFeature.id}
                        sectionRef={sectionRefs.get(gradeFeature.id as CarConfigHighlightSection)}
                        key={gradeFeature.id}
                    >
                        <ContentSection
                            gradeFeature={gradeFeature}
                            contentPosition={numberIsEven(index) ? "end" : "start"}
                        />
                    </SectionWrapper>
                ))}
            </main>
            <HighlightsNavigation />
        </div>
    );
};

export default Highlights;
